/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gym_Equipment_RequiredInputs */

const en_us2_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick at least one piece of equipment first.`)
};

const pt_br2_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um equipamento antes.`)
};

const es_419_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un equipo primero.`)
};

const pt_pt2_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca primeiro pelo menos um equipamento.`)
};

const fr_fr2_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coche d'abord au moins un équipement.`)
};

const de_de2_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiere zuerst mindestens ein Gerät.`)
};

const it_it2_gym_equipment_required = /** @type {(inputs: Gym_Equipment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona prima almeno un attrezzo.`)
};

/**
* | output |
* | --- |
* | "Tick at least one piece of equipment first." |
*
* @param {Gym_Equipment_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_equipment_required = /** @type {((inputs?: Gym_Equipment_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Equipment_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_equipment_required(inputs)
	if (locale === "es-419") return es_419_gym_equipment_required(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_equipment_required(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_equipment_required(inputs)
	if (locale === "de-DE") return de_de2_gym_equipment_required(inputs)
	if (locale === "it-IT") return it_it2_gym_equipment_required(inputs)
	return en_us2_gym_equipment_required(inputs)
});
export { gym_equipment_required as "gym.equipment_required" }